import React from "react";
import { Link } from "react-router-dom";
import "./about.css";

const About = () => {
  return (
    <section className="about" id="about">
      <div className="about__container">
        <div className="about__typography">
          <span>about me</span>
          <span>about me</span>
          <span>about me</span>
        </div>
        <div className="about__text">
          <p>
            Hi, I'm Ramzy, also known as Zii.
            <span className="about__outline">
              {" "}
              I'm an Informatics student who enjoys building web projects, exploring digital design, and creating meaningful technology-based solutions.
            </span>
          </p>
          <p>
            In my creative journey,
            <span className="about__outline">
              {" "}
              I love turning ideas into simple, useful, and aesthetic digital experiences.
            </span>
          </p>
          <div className="about__button">
            <Link to="/info" className="about__btn-pill">
              <i className="uil uil-arrow-right"></i> MORE ABOUT ME
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
